import {
  Box,
  Button,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { PartnerLogoValue } from './renderPartnerLogo';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useState } from 'react';

interface PartnerMasterDetailProps {
  value: any;
}

const PartnerMasterDetailValue = ({ value }: PartnerMasterDetailProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ width: '100%' }}>
      <Button
        onClick={() => setOpen(!open)}
        variant="text"
        startIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      >
        {value.buttonTitle}
      </Button>
      <Collapse in={open} timeout="auto" sx={{ overflowX: 'scroll' }}>
        <Box sx={{}}>
          <Table size="small" aria-label="purchases">
            <TableHead>
              <TableRow>
                {value.headers.map((header: string, index: number) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {value.rows.map((cells: Array<string>, index: number) => (
                <TableRow key={index}>
                  {cells.map((cell: string, index2: number) => (
                    <TableCell key={index2}>{cell}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Collapse>
    </Box>
  );
};

export function renderPartnerMasterDetail(
  params: GridRenderCellParams<any, any, any>
) {
  if (params.rowNode.isAutoGenerated || params.value == null) {
    return '';
  }

  if (params.value?.partnerMasterDetail) {
    return (
      <PartnerMasterDetailValue value={params.value?.partnerMasterDetail} />
    );
  }

  return <PartnerLogoValue value={{ partnerUuid: params.value.partnerUuid }} />;
}
